import React, { Component } from 'react'
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap';

import ThinkingTalentsFullReportItem from './thinking-talents-full-report-item';
import { MemberItem } from './thinking-talents-full-report-member-item';
import { QuadrantTalent } from './thinking-talents-full-report-quadrant-talent';

class ThinkingTalentsFullReport extends Component {

    constructor(props) {
        super(props)

        this.state = {
            animationClass: {
                enter: 'animate__animated',
                enterActive: 'animate__animated animate__fadeIn',
                exit: 'animate__animated',
                exitActive: 'animate__animated animate__fadeOut',
            },
            modal: {
                isOpen: false,
                quadrant: null,
                item: null,
            }
        }
        this.toggleModal = this.toggleModal.bind(this);
    }

    toggleModal = (quadrant = null, item = null) => {
        this.setState(prevState => ({
            modal: {
                isOpen: (quadrant || item) !== null,
                quadrant,
                item
            }
        }));
    };

    render() {
        const { modal } = this.state;
        const { team_full_report } = this.props;

        const referencia = team_full_report.quadrants.map((quadrant) => (
            <div className="mb-0 ml-3" key={quadrant.id}>
                <i className="icon mr-1">
                    <svg width="10" height="10" className={`mt-n1 text-${quadrant.name.toLowerCase()}`}>
                        <circle cx="5" cy="5" r="5" fill="currentColor" />
                    </svg>
                </i>
                <span>{quadrant.name}: </span>
                <div className='rounded-circle bg-always p-1 d-inline-block badge-talent'>
                    <span className='small font-weight-semibold'>{quadrant.total_members}</span>
                </div>
                <div className='rounded-circle bg-never p-1 d-inline-block badge-talent'>
                    <span className='small font-weight-semibold'>{quadrant.total_members_energy_never}</span>
                </div>
            </div>
        ))

        const energyItems = <>
            <p className="mb-0 mr-3">
                <i className="icon mr-2">
                    <svg width="16" height="16" className="mt-n1 text-always">
                        <circle cx="8" cy="8" r="8" fill="currentColor" />
                    </svg>
                </i><span className='small'><strong> Always </strong></span>
            </p>
            <p className="mb-0 mr-3">
                <i className="icon mr-2">
                    <svg width="16" height="16" className="mt-n1 text-never">
                        <circle cx="8" cy="8" r="8" fill="currentColor" />
                    </svg>
                </i><span className='small'><strong> Never </strong></span>
            </p>
        </>

        const modal_content = (modal.quadrant || modal.item) ? (
            <div className={"modal-quadrant-" + modal.quadrant.name.toLowerCase()}>
                <div className="d-flex align-items-center mb-3">
                    <div className="mb-0 mr-3">
                        <img className="icon" width="60" height="60" src={modal.quadrant.icon} alt={modal.quadrant.name} />
                    </div>
                    <h2 className="libre-caslon-text-regular text-capitalize mb-0 h4">{modal.quadrant.name}</h2>
                </div>
                <div dangerouslySetInnerHTML={{ __html: modal.quadrant.description }}></div>

                {modal.item
                    ? <>
                        <div className="d-flex align-items-center mb-3">
                            <Button color='link' onClick={() => this.toggleModal(modal.quadrant)} className="p-0 d-md-none text-body mr-2">
                                <svg xmlns="http://www.w3.org/2000/svg" width={28} height={29} viewBox="0 0 28 29" fill='currentColor'>
                                    <path d="M24.5,14.5c0,0.2-0.1,0.5-0.3,0.6c-0.2,0.2-0.4,0.3-0.6,0.3H6.5l6.4,6.4c0.1,0.1,0.1,0.2,0.2,0.3
                                                      c0,0.1,0.1,0.2,0.1,0.3s0,0.2-0.1,0.3c0,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.3-0.1
                                                      c-0.1,0-0.2-0.1-0.3-0.2l-7.9-7.9c-0.1-0.1-0.1-0.2-0.2-0.3c0-0.1-0.1-0.2-0.1-0.3c0-0.1,0-0.2,0.1-0.3c0-0.1,0.1-0.2,0.2-0.3
                                                      L11.6,6c0.2-0.2,0.4-0.3,0.6-0.3c0.2,0,0.5,0.1,0.6,0.3c0.2,0.2,0.3,0.4,0.3,0.6c0,0.2-0.1,0.5-0.3,0.6l-6.4,6.4h17.1
                                                      c0.2,0,0.5,0.1,0.6,0.3C24.4,14,24.5,14.3,24.5,14.5z"/>
                                </svg>
                            </Button>
                            <div className={`mb-0 mr-3 p-2 rounded-circle bg-${modal.quadrant.name.toLowerCase()}`}>
                                <img className={`icon ${modal.quadrant.name.toLowerCase() === 'innovative' ? '' : 'icon-inverse'}`} width="32" height="32" src={modal.item.icon_invert} alt={modal.item.name} />
                            </div>
                            <h3 className="text-capitalize mb-0 h4">{modal.item.name}</h3>

                        </div>
                        <div className="member-list">
                            {modal.item.members.map(member => (
                                <MemberItem key={`always_${member.id}`} member={member} energyType="always" />
                            ))}

                            {modal.item.members_energy_never.map(member => (
                                <MemberItem key={`never_${member.id}`} member={member} energyType="never" />
                            ))}
                        </div>
                    </>

                    : <div>
                        <div className='d-flex justify-content-start'>
                            {energyItems}
                        </div>
                        <div className="mt-2">
                            {modal.quadrant.items.map(item => (
                                <QuadrantTalent
                                    key={item.id}
                                    title={item.name}
                                    icon={item.icon}
                                    iconInvert={item.icon_invert}
                                    quadrantName={modal.quadrant.name}
                                    totalAlways={item.total_members}
                                    totalNever={item.total_members_energy_never}
                                    onClick={() => this.toggleModal(modal.quadrant, item)}
                                />
                            ))}
                        </div>
                    </div>
                }
            </div>
        ) : null

        return (
            <>
                <div className="full-report">
                    <div className='border-md rounded p-md-3'>
                        <div className='mb-3'>
                            <div className="d-lg-flex justify-content-between align-items-center mb-3">
                                <div className='d-flex justify-content-center justify-content-lg-start'>
                                    {energyItems}
                                </div>
                                <div className='d-lg-flex align-items-center ml-3 text-nowrap d-none'>
                                    {referencia}
                                </div>
                            </div>
                            <div className='d-none d-lg block text-center'><p className='text-muted small'><i>Note that numbers show the number of members who completed the assessment and have always and never energy of the talent.</i></p></div>
                        </div>

                        <div className='quadrants-list full-report'>
                            {team_full_report.quadrants.map((quadrant) => (
                                <div key={quadrant.id} quadrant_color={quadrant.color} className={`p-lg-3 border rounded border-${quadrant.name.toLowerCase()}`}>
                                    <div className='d-lg-none'>
                                        <Button color='link' className='d-block w-100 text-decoration-none text-body' onClick={() => this.toggleModal(quadrant)} >
                                            <h3 className={`h5 mb-0 quadrant-name mb-2 text-${quadrant.name.toLowerCase()}`}>{quadrant.name === 'All' ? 'Talents In All Quadrants' : quadrant.name}</h3>
                                            <div>
                                                <div className='rounded-circle bg-always p-1 d-inline-block badge-talent'>
                                                    <span className='small font-weight-semibold'>{quadrant.total_members}</span>
                                                </div>
                                                <div className='rounded-circle bg-never p-1 d-inline-block badge-talent'>
                                                    <span className='small font-weight-semibold'>{quadrant.total_members_energy_never}</span>
                                                </div>
                                            </div>
                                            <p className='text-muted mb-0'><small><i>Tap to view more</i></small></p>
                                        </Button>
                                    </div>
                                    <div className='d-lg-block d-none'>
                                        <div className='text-center mb-3'>
                                            <h3 className={`h4 mb-0 quadrant-name text-${quadrant.name.toLowerCase()}`}>{quadrant.name === 'All' ? 'Talents In All Quadrants' : quadrant.name}</h3>
                                            <p className='small text-muted'>{quadrant.excerpt}</p>
                                        </div>
                                        <div className="d-flex flex-wrap justify-content-around row-cols-3 row-cols-md-4">
                                            {quadrant.items.map(item =>
                                                <div className="cursor-pointer" onClick={() => this.toggleModal(quadrant, item)} key={item.id}>
                                                    <ThinkingTalentsFullReportItem item={item} />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <Modal isOpen={this.state.modal.isOpen} toggle={() => this.toggleModal()} size='sm' className="w-100 modal-dialog-summary float-right">
                    <ModalHeader toggle={() => this.toggleModal()} className='pb-0'></ModalHeader>
                    <ModalBody className='pt-2'>
                        {modal_content}
                    </ModalBody>
                </Modal>
            </>
        )
    }
}

export default ThinkingTalentsFullReport;
